import { Radio, RadioGroupProps as ArcoRadioGroupProps } from '@arco-design/web-react';
import { merge } from 'lodash';
import React from 'react';
import { Stack } from '@bay-email/editor';
import styles from './index.module.scss';

export interface RadioGroupProps extends ArcoRadioGroupProps {
	options: Array<{ value: string; label: React.ReactNode }>;
	onChange?: (value: string) => void;
	value?: string;
	type?: 'radio' | 'button';
	vertical?: boolean;
}

export function RadioGroup(props: RadioGroupProps) {
	const { type, vertical, ...rest } = props;
	const className = [rest.className, type === 'button' ? styles.radioGroupButtons : '']
		.filter(Boolean)
		.join(' ');
	const groupStyle = merge(
		{
			width: '100%',
			...(type === 'button'
				? {
						display: 'grid',
						gridTemplateColumns: `repeat(${Math.max(rest.options.length, 1)}, minmax(0, 1fr))`,
						gap: '8px',
					}
				: {}),
		},
		rest.style,
	);

	return (
		<Radio.Group
			{...rest}
			className={className}
			type={type}
			style={groupStyle}
			value={rest.value}
			onChange={rest.onChange}
		>
			{type === 'button' ? (
				rest.options.map((item, index) => (
					<Radio
						key={index}
						value={item.value}
					>
						{item.label}
					</Radio>
				))
			) : (
				<Stack
					vertical={vertical}
					spacing='extraTight'
				>
					{rest.options.map((item, index) => (
						<Radio
							key={index}
							value={item.value}
						>
							{item.label}
						</Radio>
					))}
				</Stack>
			)}
		</Radio.Group>
	);
}
